import { Link } from "react-router-dom";
import { Shield } from "lucide-react";
import { Checkbox } from "@/ui/base/checkbox";

/**
 * Aviso de tratamento de dado pessoal, para pé de formulário.
 *
 * O endereço do aviso de privacidade é `/privacidade` — o prefixo `/teg` deixou de
 * existir no Prompt 6, e o link apontava para rota inexistente. `target="_blank"`
 * saiu junto: abrir aba sem avisar surpreende quem usa leitor de tela, e o
 * documento abre bem na mesma aba (o formulário nao se perde: o preenchimento
 * sobrevive ao voltar).
 */
interface LgpdNoticeProps {
  /** Custom purpose text, e.g. "para processar a inscrição no programa TEG" */
  purpose: string;
  /** "info" = read-only notice; "consent" = with checkbox */
  variant?: "info" | "consent";
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}

export function LgpdNotice({ purpose, variant = "info", checked, onCheckedChange }: LgpdNoticeProps) {
  const isConsent = variant === "consent";

  return (
    <div className="rounded-xl border bg-muted/40 p-4 space-y-3">
      <div className="flex items-start gap-3">
        <Shield className="h-5 w-5 text-primary shrink-0 mt-0.5" />
        <div className="space-y-1 text-sm">
          <p className="font-medium text-foreground">Proteção de Dados Pessoais (LGPD)</p>
          <p className="text-muted-foreground leading-relaxed">
            Os dados informados neste formulário serão tratados pela Prefeitura de São Paulo, por meio da
            Secretaria Municipal de Mobilidade Urbana e Transporte, exclusivamente {purpose}, em
            conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018).{" "}
            <Link to="/privacidade" className="text-link underline underline-offset-2 hover:no-underline">
              Leia o aviso de privacidade
            </Link>.
          </p>
        </div>
      </div>

      {isConsent && (
        <div className="flex items-start gap-2 pl-8">
          <Checkbox
            id="lgpd-consent"
            checked={checked}
            onCheckedChange={(v) => onCheckedChange?.(!!v)}
            className="mt-0.5"
          />
          <label htmlFor="lgpd-consent" className="text-sm text-foreground cursor-pointer leading-relaxed">
            Declaro que li e concordo com a Política de Privacidade e autorizo o tratamento dos meus dados
            pessoais para a finalidade descrita acima.
          </label>
        </div>
      )}
    </div>
  );
}
